import arrayMutators from 'final-form-arrays';
import { func } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Form as FinalForm } from 'react-final-form';
// These relative imports need to point to correct directories
import { useDispatch } from 'react-redux';
import { Button, Form } from '../../components';
import { updateProfile } from '../../containers/ProfileSettingsPage/ProfileSettingsPage.duck';
import { onGetCategories } from '../../util/api';
import { transformDbCategories } from '../../util/data';
import {
  FormattedMessage,
  intlShape
} from '../../util/reactIntl';
import css from "./InterestsForm.module.css";
import IconCollection from '../IconCollection/IconCollection';
import { trackEventsMixpanel } from '../../mixpanel/mixpanel';
import { Events, mixPanelEventsData, mixPanelEventsScreens } from '../../mixpanel';

const InterestsForm = props => {
  return (
    <FinalForm
      {...props}
      mutators={{
        ...arrayMutators,
      }}
      render={formRenderProps => {
        const {
          disabled,
          handleSubmit,
          intl,
          invalid,
          pristine,
          updated,
          formId,
          updateError,
          updateInProgress,
          values,
          form,
          successToaster,
          errorToaster,
          currentUser,
          handleInterestModalClose,
        } = formRenderProps;

        const { userType, userInterests } = currentUser?.attributes?.profile?.publicData || {}
        const currentUserId = currentUser?.id?.uuid;

        const isCustomer = userType === 'customer';

        const [interests, setInterests] = useState([]);
        const [selectedInterests, setSelectedInterests] = useState([]);
        const [isLoading, setIsLoading] = useState(false);
        const dispatch = useDispatch();

        const errorMessage = updateError ? (
          <p className={css.error}>
            <FormattedMessage id="ContactUsForm.updateFailed" />
          </p>
        ) : null;

        const submitReady = updated && pristine;
        const submitInProgress = updateInProgress || isLoading;
        const submitDisabled = invalid || disabled || submitInProgress || !(selectedInterests?.length > 0 && selectedInterests?.length <= 5);

        useEffect(() => {
          const fetchInterest = async () => {
            const response = await onGetCategories();
            const organized = transformDbCategories(response || []);
            setInterests(organized)
          }

          if (isCustomer && !userInterests?.length) {
            fetchInterest();
          }
        }, [])

        return (
          <Form onSubmit={(e) => {
            e.preventDefault();
            setIsLoading(true);
            const subcategorySlugs = interests
              .filter(category => selectedInterests.includes(category.slug))
              .flatMap(category => (category.childCategory || []).map(sub => sub.slug));
            dispatch(updateProfile({ publicData: { userInterests: subcategorySlugs } }))
              .then(() => {
                setIsLoading(false);
                handleInterestModalClose();
                trackEventsMixpanel(Events.CUSTOMER_SIGNUP_COMPLETE,
                  {
                    action_type: mixPanelEventsData.CUSTOMER_SETUP_INTERESTS,
                    screen: mixPanelEventsScreens.INTEREST_SELECTION,
                    user_type: 'customer',
                    user_id: currentUserId,
                  }
                );
              })
          }}
            className={css.mainForm}
          >
            <div className={css.verifyBox}>
              <h3 className={css.verifyTitle}>
                <FormattedMessage id="InterestsForm.heading" />
              </h3>
              <p className={css.verifySubTitle}>
                <FormattedMessage id="InterestsForm.subHeading" />
              </p>
              {interests?.length > 0 ? (
                interests.map(category => {
                  const { slug, label } = category || {};
                  const isChecked = selectedInterests?.includes(slug);
                  return (
                    <div key={slug} className={css.itemCheckbox} onClick={() => setSelectedInterests(prevState =>
                      prevState.includes(slug)
                        ? prevState.filter(int => int !== slug)
                        : [...prevState, slug]
                    )}
                    >
                      <span>
                        {isChecked ?
                          <IconCollection name="interest_checked" />
                          :
                          <IconCollection name="interest_notChecked" />

                        }
                      </span>
                      {label}
                    </div>
                  )
                })
              ) : null}

              {selectedInterests?.length > 5 ? (
                <FormattedMessage id="InterestsForm.selectMaxFive" />
              ) : null}

              <Button
                className={css.buttonSubmit}
                type="submit"
                inProgress={submitInProgress}
                disabled={submitDisabled}
                ready={submitReady}
              >
                <FormattedMessage id="InterestsForm.submitButtonLabel" />
              </Button>
            </div>
          </Form>
        );
      }}
    />
  )
}

InterestsForm.defaultProps = {
  selectedPlace: null,
  updateError: null,
};

InterestsForm.propTypes = {
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  //   updateInProgress: bool.isRequired,
};

export default InterestsForm;
